import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { AuthFacade } from '../../authentication/data-access/facades/auth.facade';

/**
 * Restaura la sesión (cookie de refresh → access token en memoria) antes de que arranque el router,
 * así `authGuard` ya ve el estado definitivo en la primera navegación.
 */
export function provideSessionRestore(): EnvironmentProviders {
  return provideAppInitializer(() => inject(AuthFacade).restoreSession());
}
